/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, { useCallback, useContext, useState, useMemo } from 'react';
import { InlineNotification, Loader, useModal } from '@jutro/components';
import CustomLoader from "producer-engage/src/components/CustomLoader/CustomLoader.jsx";
import { useTranslator } from '@jutro/locale';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil';
import { GatewayEndorsementService as LoadSaveService} from 'twia-capability-gateway-policychange';
import { ENTDdocumentUploadComponent } from 'gw-capability-gateway-react';
import AdditionalInterestComponent from 'twia-capability-quoteandbind-residential-react/components/AdditionalInformation/AdditionalInterestComponent/AdditionalInterestComponent.jsx';
import AdditionalInsuredComponent from 'twia-capability-quoteandbind-residential-react/components/AdditionalInformation/AdditionalInsuredComponent/AdditionalInsuredComponent.jsx';
// import PrintDocumentUtil from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtil.js';
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import PrintDocumentUtils from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtils.js';
import PrintDocumentConfirmationPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentConfirmationPopup';
import PrintDocumentErrorPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentErrorPopup';
import metadata from './AdditionalInformationPage.metadata.json5';
import  './AdditionalInformationPage.messages.js';
import styles from './AdditionalInformationPage.module.scss';

const LOB_PATH = {
    PersonalAuto: 'lobData.personalAuto.preQualQuestionSets.children[0].value',
    Homeowners: 'lobData.homeowners.preQualQuestionSets.children[0].value',
    HOPHomeowners: 'lobData.homeowners.preQualQuestionSets.children[0].value',
    BusinessOwners:
        'lobData.businessOwners.preQualQuestionSets.children[0].value',
    BusinessAuto:
        'lobData.businessOwners.preQualQuestionSets.children[0].value',
};

function TWIAAdditionalInformationPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { wizardData: submissionVM, updateWizardData, onResolve, onAfterClose } = props;
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const [isLoading, setIsLoading] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);
    const { showAlert, showConfirm, showModal } = useModal();
    const [invalidComponent, setInvalidComponents] = useState([]);
    const [showErrors, setShowErrors] = useState(false);
    const isPolicyChange = _.get(submissionVM, 'baseData.jobType.value.code') === 'PolicyChange';
    const jobNumber = isPolicyChange ? _.get(submissionVM, 'jobID.value') : _.get(submissionVM, 'quoteID.value');
    const jobType = _.get(submissionVM, 'baseData.jobType.value.code');
    const productCode = _.get(submissionVM, 'baseData.productName.value');
    const [validationMessages, setValidationMessages] = useState([]);
    const uwCompany = 'twia';
    const {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        registerInitialComponentValidation,
        isComponentValid,
        initialValidation,
        onValidate,
    } = useValidation('TWIAAdditionalInformationPage');
    
    const resetElectronicPaymentData = useCallback(() => {
        const epayData = _.get(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA');

        if (epayData && epayData.aspects && !epayData.aspects.subtreeValid) {
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA.value', null);
            updateWizardData(submissionVM);
        }
    }, [submissionVM, updateWizardData]);

    const onNext = useCallback(async () => {

        if (invalidComponent.length > 0) {
            setShowErrors(true)
            return false;
        }

        setShowErrors(false);

        try {
            resetElectronicPaymentData();
            submissionVM.validationParams_TWIA.value = {
                validationLevel: 'default',
                validationWizardStep: 'AdditionalInfo',
                skipAllValidation: false
            };
            submissionVM.value = await LoadSaveService.saveQuotedEndorsement_TWIA(
                submissionVM.value,
                authHeader
            )

            const validationIssues = _.get(submissionVM, 'errorsAndWarnings.value.validationIssues.issues');

            if (validationIssues && validationIssues.length > 0) {
                setShowErrors(true);
                setValidationMessages(_.uniq(validationIssues.map(vi => vi.reason)));

                return false;
            }

            return submissionVM;
        } catch (error) {
            ErrorPopupUtil.showSaveErrorPopup(showAlert, true);

            return false;
        }
    }, [authHeader, invalidComponent.length, resetElectronicPaymentData, showAlert, submissionVM]);

    const errorContent = useCallback(
        item => (
                <InlineNotification id={item} 
                message={item}
                type= "error"
                className= {styles.marginBottom}
                isDismissable= {false}
                />
            ),
        []
    );
    
    const generateOverrides = useMemo(() => {
        const overrides = validationMessages.map((item, index) => ({
                [`errorMsg${index}`]: {
                    content: errorContent(item),
                },
            }));
        
        return Object.assign({}, ...overrides);
    }, [validationMessages, errorContent]);

    const findInvalidComponent = useCallback((isValid, componentID) => {
        setShowErrors(false);
        
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    // const quotePrintDocument = useCallback(async () => {
    //     setIsPrinting(true);
    //     await PrintDocumentUtil.printDocument(submissionVM, showConfirm, showAlert, translator, authHeader, setIsPrinting);
    // }, [authHeader, showAlert, showConfirm, submissionVM, translator])

    const quotePrintDocument = useCallback(() => {
        const {getPublicID, getPath, getQuoteStatus} = PrintDocumentUtils(submissionVM);
        setIsPrinting(true);
        
        const publicID = getPublicID();
        const docPath = getPath();
        const quoteStatus = getQuoteStatus();       
        const componentProps = { submissionVM, setIsPrinting, isOpen: true, onResolve, onAfterClose, docPath, quoteStatus};       
        if (quoteStatus === 'Quoted' || quoteStatus === 'Submitted_Ext' || quoteStatus === 'Renewing') {
            CustomQuoteService.generateDocument_TWIA(publicID, 'quoteSummary', authHeader).then(() => {
                showModal(<PrintDocumentConfirmationPopup {...componentProps} />);
            });
        }  else {
            showModal(<PrintDocumentErrorPopup {...componentProps} />);
        }
    }, [authHeader, onAfterClose, onResolve, showModal, submissionVM])

    const skipCondition = useCallback(
        () => {
            if (initialValidation && !_.isNull(isComponentValid)) {
                return initialValidation() && isComponentValid;
            }
            const validationIssues = _.get(submissionVM, 'errorsAndWarnings.value.validationIssues.issues');
            return initialValidation() && !_.isUndefined(validationIssues?.length) ?  validationIssues?.length === 0 : true;
        }, [initialValidation, isComponentValid, submissionVM]
    );

    const overrideProps = {
        '@field': {
            // apply to all fields
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        questionSets: {
            path: LOB_PATH.Homeowners
        },
        AdditionalInterests: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate
        },
        AdditionalInsureds: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate
        },
        additionalInterestsAccordion: {
            errorState: _.includes(invalidComponent, 'AdditionalInterestDetails') && showErrors
        },
        additionalInsuredsAccordion: {
            errorState: _.includes(invalidComponent, 'AdditionalInsuredDetails') && showErrors
        },
        // 2025-05-22 - Debra Frum - DE19212 - TWIA Underwriting Response activities are triggering under open transactions
        //   Functionality for TWIA didn't get implemented when TFPA & TWIA portals merged during move to Guidewire Cloud
        // 2022-05-24 - Debra Frum - US22167 - PC / PE Underwriting Response Activity
        //   Don't create a Review activity when a document is uploaded within a TWIA transaction workflow
        uploadDocumentsDetails: {
            jobNumber, jobType, productCode, uwCompany, skipReviewActivity: true
        },
        infoMessage: {
            data: validationMessages
        },
        quotePagePrint: {
            visible : !isPrinting
        },
        cLoader: {
            visible: isPrinting
        },
        ...generateOverrides,    
        
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: { 
            AdditionalInterestsComponent: AdditionalInterestComponent,
            AdditionalInsuredsComponent: AdditionalInsuredComponent ,
            documentUploadComponent: ENTDdocumentUploadComponent,
            customLoader: CustomLoader
        },
        resolveCallbackMap: {
            quotePrintDocument,
        },
    };

    return (
      
        <WizardPage
            onNext={onNext}
            skipWhen={skipCondition}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    overrideProps={overrideProps}
                    onModelChange={updateWizardData}
                    showErrors={showErrors}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </Loader>
        </WizardPage>
    );
}

TWIAAdditionalInformationPage.propTypes = wizardProps;
export default TWIAAdditionalInformationPage;
